import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export default function ConfigurationDetails({
  item,
  handleFormSubmit,  
  onClose
}: any) {

  console.log('item', item)

  return (
    <>
      <div className="flex justify-center items-center w-full">
        <div className="w-full p-4 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{`Gateway Basic Settings`}</h1>
          <div className='pt-4 grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
            <InputContainer
              label="Open Network Gateway"
              name="bg_uri"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.bg_uri}
            />
            <InputContainer
              label="BPP URI"
              name="bpp_uri"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.bpp_uri}
            />
            <InputContainer
              label="Tenant Name"
              name="tenant"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.tenant}
            />
            <InputContainer
              label="Requester"
              name="requester"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.requester}
            />
            {/* <InputContainer
              label="store_id"
              name="store_id"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.store_id}
            /> */}
            {/* <InputContainer
              label="channel_id"
              name="channel_id"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.channel_id}
            /> */}
            <InputContainer
              label="Channel Name"
              name="channel_name"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.channel_name}
            />
            <InputContainer
              label="Email Domain"
              name="email_domain"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.email_domain}
            />
            
            <InputContainer
              label="Default User Email"
              name="default_user_email"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.default_user_email}
            />
            <InputContainer
              label="Default User Phone"
              name="default_user_phone"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.default_user_phone}
            />
            <InputContainer
              label="Account Id"
              name="account_id"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.account_id}
            />
            
            <InputContainer
              label="Application Secret key"
              name="secretkey"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.secretkey}
            />
            <InputContainer
              label="ONDC NO Token"
              name="ONDC_TOKEN"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.ONDC_TOKEN}
            />
            
            <InputContainer
              label="Enable Debugging"
              name="debugger"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.debugger?.enabled}
            />
            <InputContainer
              label="Logging Level"
              name="level"
              // onValueChange={(event: any) => {
              //   handleInnerFormChange(
              //     event.target.value,
              //     'Name',
              //   )
              // }}
              type="text"
              value={item?.debugger?.level}
            />
            


          </div>          
        </div>
      </div>

    </>
  )
}